export { default } from './ConstructorText';
